import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Products from './pages/Products';
import Services from './pages/Services';
import TransportManagementSystem from './pages/TransportManagementSystem';
import Payroll from './pages/Payroll';
import GPSTrackingSoftware from './pages/GPSTrackingSoftware';
import Applications from './pages/Applications';
import EnterpriseResourcePlanning from './pages/EnterpriseResourcePlanning';
import Consulting from './pages/Consulting';
import Mobility from './pages/Mobility';
import BusinessProcess from './pages/BusinessProcess';
import GPSTrackingService from './pages/GPSTrackingService';
import Careers from './pages/Careers';
import TMSPricing from './pages/TMSPricing';
import Sitemap from './pages/Sitemap';
import PrivacyPolicy from './pages/PrivacyPolicy';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/products" element={<Products />} />
        <Route path="/services" element={<Services />} />
        <Route path="/transport-management-system" element={<TransportManagementSystem />} />
        <Route path="/payroll" element={<Payroll />} />
        <Route path="/gps-tracking-software" element={<GPSTrackingSoftware />} />
        <Route path="/applications" element={<Applications />} />
        <Route path="/enterprise-resource-planning" element={<EnterpriseResourcePlanning />} />
        <Route path="/consulting" element={<Consulting />} />
        <Route path="/mobility" element={<Mobility />} />
        <Route path="/business-process" element={<BusinessProcess />} />
        <Route path="/gps-tracking-service" element={<GPSTrackingService />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/tms-pricing" element={<TMSPricing />} />
        <Route path="/sitemap" element={<Sitemap />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      </Routes>
    </Router>
  );
}

export default App;

